import React, { useEffect, useState, useRef } from "react";
import {
  bp_material_data,
  save_manual_qr_code_for_ingredent,
  save_manual_qr_code_for_machine,
  ImportIngredentQR,
  bp_machine_data,
  get_api_function,
} from "../../../utils/api";
import { toast } from "react-toastify";
import { Table, Image, Modal, Select, Button, Tooltip, Input, Divider, Segmented } from "antd";
import { Plus, FileText, Printer } from "lucide-react";
import sample_qr_data from "../../../assets/third-party/sample_qr_data.xlsx";
import AddIngredient from "./AddIngredients";
import MainCard from '@/components/MainCard';
import { downloadPDF } from '@/pages/reusable_functions';
import { useDispatch, useSelector } from "react-redux";
import QrPrinter from '@/components/third-party/QrPrinter';
import { useLocation } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from "react-i18next";
import { formatDateTime } from '@/utils/datetime';
import DataTable from '@/components/DataTable';
import PageHeader from '@/components/PageHeader';


function GenerateQRs({ show_config }) {
  const { t } = useTranslation();

  const inputRef = useRef(null);
  const formattedDate = new Date().toISOString().split("T")[0];
  const componentRef = useRef();
  const [modal_open, set_modal_open] = useState(false);
  const [inventoryData, setInventoryData] = useState();
  const [qr_data, set_qr_data] = useState([]);
  const [qr_submit_data, set_qr_submit_data] = useState([]);
  const [qr_file, set_qr_file] = useState([]);
  const [machine_data, set_machine_data] = useState([]);
  const [show_qr, set_show_qr] = useState(false);
  const [material_unit, set_material_unit] = useState("");
  const [selectedMaterial, set_selectedMaterial] = useState("");
  const [selectedMaterialUnit, set_selectedMaterialUnit] = useState("");
  const [qr_image, set_qr_image] = useState();
  const location = useLocation();
  const { from } = location.state || {};
  const [activeButton, setActiveButton] = useState("bulk");
  const [selectedMachine, set_selectedMachine] = useState("");
  const selectedModule = useSelector((state) => state.moduleView);

  // Define the PrintableComponent
  const PrintableComponent = React.forwardRef(({ imageUrl, text }, ref) => {
    return (
      <div ref={ref} style={{ textAlign: "center" }}>
        <img
          src={imageUrl}
          alt="Printable"
          style={{ maxWidth: "100%", marginBottom: "10px" }}
        />
        <p>{text}</p>
      </div>
    );
  });

  const [qr_obj, set_qr_obj] = useState({
    ingredent_material_id: "",
    quantity: 1,
    no_of_qr: 1,
    ingredent_material_name: "",
    bag_number: "",
    bag_size: "",
    lot_number: "",
    opening_date: "",
    expiry_date: "",
    random_quantity: "",
    qr_type: "bulk",
    material_unique_id: "",
  });

  const inventoryDetailColumns = [
    {
      dataIndex: "ingredent_material_name",
      title: "Material Name",
      key: "ingredent_material_name",
      width: "8%",
      render: (_, record) => record?.ingredent_material_name,
    },
    {
      dataIndex: "material_unique_id",
      title: "Material Unique Id",
      key: "material_unique_id",
      width: "8%",
    },
    {
      dataIndex: "bag_number",
      title: "Bag Number",
      key: "bag_number",
      width: "8%",
    },
    {
      dataIndex: "bag_size",
      title: "Bag Weight",
      key: "bag_number",
      width: "8%",
    },
    {
      dataIndex: "quantity",
      title: "Total Packs",
      key: "quantity",
      width: "8%",
      align: "center",
    },
    {
      dataIndex: "ingredent_material_unit",
      title: "Unit",
      key: "unit",
      width: "8%",
    },
    {
      dataIndex: "lot_number",
      title: "Lot No.",
      key: "lot_number",
      align: "center",
      width: "8%",
    },
    {
      dataIndex: "opening_date",
      title: "Mfg Date",
      key: "opening_date",
      width: "8%",
      align: "center",
    },
    {
      dataIndex: "expiry_date",
      title: "Expiry Date",
      key: "expiry_date",
      width: "8%",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => {
        return (
          <Button
            type="primary"
            size="small"
            style={{
              backgroundColor: defaultColors.primary,
              borderColor: defaultColors.primary,
            }}
            onClick={() => {
              save_manual_qr_code_for_ingredent(
                { data_flow: [record], qr_type: record?.qr_type },
                success_add_inventory
              );
            }}
          >
            Generate
          </Button>
        );
      },
    },
  ]?.filter(Boolean);

  const machineColumns = [
    {
      dataIndex: "machine_name",
      title: "Machine Name",
      key: "machine_name",
      width: "8%",
    },
    {
      dataIndex: "machine_type",
      title: "Machine Type",
      key: "machine_type",
      width: "8%",
    },
    {
      dataIndex: "installation_date",
      title: "Installation Date",
      key: "installation_date",
      width: "8%",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => {
        return (
          <Button
            type="primary"
            size="small"
            style={{
              backgroundColor: defaultColors.primary,
              borderColor: defaultColors.primary,
            }}
            onClick={() => {
              generate_qr(record?.machine_id);
            }}
          >
            Generate
          </Button>
        );
      },
    },
  ]?.filter(Boolean);

  //####################### Handle Api's######################################################

  const get_all_inventory = async () => {
    try {
      await bp_material_data({ module_type: selectedModule }, success_inventory_list_get);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const success_inventory_list_get = (res) => {
    setInventoryData(res?.data?.data);
  };

  const getmachines = async () => {
    try {
      await get_api_function("/bp_get_machine_data", success_bp_machine_data);
    } catch (error) {
      console.log(error);
    }
  };

  const success_bp_machine_data = (res) => {
    if (res.data.status !== "failed") set_machine_data(res?.data?.data);
  };

  //Add inventory
  const generate_qr = async (machine_id) => {
    try {
      await save_manual_qr_code_for_machine(
        { machine_id: machine_id },
        success_add_machine
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const success_add_machine = (res) => {
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      set_modal_open(!modal_open);
      set_qr_submit_data(res?.data);
      if (res?.existing?.length > 0) {
        error(res?.existing);
      }
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      toast.success(res.message);
    }
  };

  const error = (exists_data) => {
    Modal.error({
      title: "Error Message",
      content: (
        // Kept as raw antd Table: Modal.error renders outside the ThemeProvider that DataTable's useTheme() needs.
        <Table
          size="small"
          bordered
          pagination={false}
          columns={[
            {
              dataIndex: "name",
              align: "center",
              title: "Name",
            },
            {
              dataIndex: "msg",
              title: "Error Message",
            },
          ]}
          dataSource={exists_data}
        />
      ),
      width: "40%",
      okText: "Close",
    });
  };

  const success_add_inventory = (res) => {
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      set_modal_open(!modal_open);
      set_qr_submit_data(res?.data);
      if (res?.existing?.length > 0) {
        error(res?.existing);
      }
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      toast.success(res.message);
    }
  };

  const reset_function = () => {
    set_qr_obj({
      ingredent_material_id: "",
      quantity: 1,
      no_of_qr: 1,
      ingredent_material_name: "",
      bag_number: "",
      bag_size: "",
      lot_number: "",
      opening_date: "",
      expiry_date: "",
      random_quantity: "",
      qr_type: "bulk",
      material_unique_id: "",
    });
  };

  useEffect(() => {
    get_all_inventory();
    getmachines();
  }, []);

  return (
    <MainCard
      title={
        <PageHeader
          compact
          icon={<Icons.QrCode size={22} />}
          title={t('Generate QR Codes')}
          description="Create and print QR labels for materials and machines."
        />
      }
    >
      {from && from !== "machine" ? (
        <>
          <div className="flex justify-end mb-4">
            <p className="text-sm text-gray-500">
              *Create QR's for materials using either an Excel upload or manual entry.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-4">
            <div className="md:col-span-3">
              <label className="font-medium mb-1">Upload File</label>
              <div className="flex gap-2">
                <Input
                  type="file"
                  id="select-excel"
                  ref={inputRef}
                  accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={(e) => {
                    set_qr_file(e.target.files);
                  }}
                />
                <a href={sample_qr_data} download="sample_file.xlsx">
                  <Tooltip title="Sample File">
                    <Button
                      type="text"
                      icon={<FileText size={24} style={{ color: defaultColors.primary }} />}
                      id="download-sample-file"
                    />
                  </Tooltip>
                </a>
              </div>
            </div>
            <div className="md:col-span-2 flex items-end">
              <Button
                type="primary"
                disabled={qr_file?.length === 0}
                style={{
                  backgroundColor: defaultColors.primary,
                  borderColor: defaultColors.primary,
                }}
                onClick={() => {
                  const userFileData = new FormData();
                  userFileData.append("file", qr_file[0]);
                  ImportIngredentQR(userFileData, success_add_inventory);
                }}
              >
                Submit
              </Button>
            </div>
          </div>
          <Divider className="my-4">OR</Divider>

          <div className="space-y-4">
            <div className="flex justify-end">
              <Segmented
                options={[
                  { label: 'Bulk', value: 'bulk' },
                  { label: 'Random', value: 'random' },
                ]}
                value={activeButton}
                onChange={(value) => {
                  reset_function();
                  setActiveButton(value);
                }}
                style={{
                  backgroundColor: defaultColors.palette.gray[100],
                }}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              <div>
                <label className="font-medium mb-1">Material</label>
                <Select
                  showSearch
                  value={qr_obj["ingredent_material_id"] || undefined}
                  size="large"
                  style={{ width: "100%" }}
                  placeholder="Select Material"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children.localeCompare(optionB.children)
                  }
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  onChange={(value) => {
                    set_qr_obj({
                      ...qr_obj,
                      ingredent_material_id: value,
                      ingredent_material_name: inventoryData?.find(
                        (item) => item?.material_id === value
                      )?.material_name,
                      material_unique_id: inventoryData?.find(
                        (item) => item?.material_id === value
                      )?.material_unique_id,
                      ingredent_material_unit:
                        inventoryData?.find(
                          (item) => item?.material_id === value
                        )?.unit || "",
                    });
                    const unit =
                      inventoryData?.find((data) => data?.material_id === value)
                        ?.unit || "";
                    set_material_unit(unit);
                  }}
                >
                  {inventoryData?.map((mdata) => (
                    <Select.Option
                      key={mdata.material_id}
                      value={mdata.material_id}
                    >
                      {mdata.material_name}
                    </Select.Option>
                  ))}
                </Select>
              </div>

              <div>
                <label className="font-medium mb-1">Material Unique Id</label>
                <Input
                  type="text"
                  size="large"
                  placeholder="Material Unique Id"
                  disabled
                  value={qr_obj["material_unique_id"]}
                  onChange={(e) =>
                    set_qr_obj({
                      ...qr_obj,
                      material_unique_id: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="font-medium mb-1">Bag Number</label>
                <Input
                  type="text"
                  size="large"
                  placeholder="Enter Bag Number"
                  value={qr_obj["bag_number"]}
                  onChange={(e) =>
                    set_qr_obj({
                      ...qr_obj,
                      bag_number: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="font-medium mb-1">Bag Weight (Each)</label>
                <Input
                  type="number"
                  size="large"
                  placeholder="Bag Weight"
                  value={qr_obj["bag_size"]}
                  suffix={<span className="text-gray-500">{material_unit}</span>}
                  min={0}
                  step="any"
                  onChange={(e) =>
                    e.target.value >= 0 &&
                    set_qr_obj({
                      ...qr_obj,
                      bag_size: parseFloat(e.target.value),
                    })
                  }
                />
              </div>

              <div>
                <label className="font-medium mb-1">Lot Number</label>
                <Input
                  type="text"
                  size="large"
                  placeholder="Enter Lot Number"
                  value={qr_obj["lot_number"]}
                  onChange={(e) =>
                    set_qr_obj({
                      ...qr_obj,
                      lot_number: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <label className="font-medium mb-1">Mfg Date</label>
                <Input
                  type="date"
                  size="large"
                  placeholder="Mfg Date"
                  value={qr_obj["opening_date"]}
                  max={formattedDate}
                  onChange={(e) => {
                    set_qr_obj({
                      ...qr_obj,
                      opening_date: e.target.value,
                    });
                  }}
                />
              </div>

              <div>
                <label className="font-medium mb-1">Expiry Date</label>
                <Input
                  type="date"
                  size="large"
                  placeholder="Select Expiry Date"
                  value={qr_obj["expiry_date"]}
                  min={qr_obj["opening_date"]}
                  onChange={(e) => {
                    set_qr_obj({
                      ...qr_obj,
                      expiry_date: e.target.value,
                    });
                  }}
                />
              </div>

              <div>
                {activeButton === "bulk" ? (
                  <>
                    <label className="font-medium mb-1">Total Packs</label>
                    <Input
                      type="number"
                      size="large"
                      placeholder="Enter Quantity"
                      value={qr_obj["quantity"]}
                      onChange={(e) =>
                        e.target.value >= 0 &&
                        set_qr_obj({
                          ...qr_obj,
                          quantity: parseInt(e.target.value),
                        })
                      }
                    />
                  </>
                ) : (
                  <>
                    <label className="font-medium mb-1">Pack</label>
                    <Input
                      type="text"
                      size="large"
                      placeholder="Enter Pack"
                      value={qr_obj["random_quantity"]}
                      onChange={(e) =>
                        set_qr_obj({
                          ...qr_obj,
                          random_quantity: e.target.value,
                        })
                      }
                    />
                  </>
                )}
              </div>

              <div className="flex items-end">
                <Button
                  type="primary"
                  size="large"
                  style={{
                    backgroundColor: defaultColors.primary,
                    borderColor: defaultColors.primary,
                  }}
                  // disabled={
                  //   activeButton === "random"
                  //     ? Object.values(qr_obj).some((item) => !Boolean(item))
                  //     : Object.entries(qr_obj)
                  //         .filter(([key]) => !["random_quantity"].includes(key))
                  //         .some(([, value]) => !Boolean(value))
                  // }
                  onClick={() => {
                    set_qr_data((data) => [
                      ...data,
                      { ...qr_obj, qr_type: activeButton },
                    ]);
                    reset_function();
                    set_qr_submit_data([]);
                  }}
                >
                  Add
                </Button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="font-medium mb-1">Machine</label>
              <Select
                showSearch
                value={selectedMachine || undefined}
                size="large"
                style={{ width: "100%" }}
                placeholder="Select machine"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                onChange={(value) => {
                  const machine = machine_data?.find(
                    (data) => data?.machine_id === value
                  );
                  const qrdata = {
                    machine_id: machine?.machine_id,
                    machine_name: machine?.name,
                    machine_type: machine?.machine_type,
                    installation_date: formatDateTime(machine?.installation_date),
                  };
                  set_qr_data((data) => [qrdata]);
                  set_selectedMachine(value);
                }}
              >
                {machine_data?.map((mdata) => (
                  <Select.Option
                    key={mdata.machine_id}
                    value={mdata.machine_id}
                  >
                    {mdata.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </>
      )}
      {qr_data?.length > 0 && (
        <div className="mt-4">
          <DataTable
            tableKey={from === "machine" ? "generateQrMachineTable" : "generateQrMaterialTable"}
            searchable
            data={qr_data}
            columns={
              from === "machine" ? machineColumns : inventoryDetailColumns
            }
            // Responsive: was 410px flat, anchored to a 900px reference viewport so it scales on larger/smaller screens
            scrollX={940}
            height="calc(100vh - 490px)"
            bordered
            pagination={false}
          />
        </div>
      )}
      <Modal
        title="Generated QR"
        open={modal_open}
        onCancel={() => {
          set_modal_open(!modal_open);
        }}
        footer={null}
        width={1200}
      >
        <DataTable
          data={qr_submit_data}
          columns={
            from === "machine"
              ? [
                  {
                    dataIndex: "machine_name",
                    title: "Machine Name",
                    key: "machine_name",
                    align: "center",
                  },
                  {
                    dataIndex: "machine_type",
                    title: "Machine Type",
                    key: "machine_type",
                    align: "center",
                  },
                  {
                    dataIndex: "installation_date",
                    title: "Installation Date",
                    key: "installation_date",
                    align: "center",
                    render: (data, record, index) => formatDateTime(data),
                  },
                  {
                    dataIndex: "qr",
                    title: "QR",
                    key: "qr",
                    width: "40%",
                    align: "center",
                    render: (_, record, index) => (
                      <Image
                        width={200}
                        src={`data:image/png;base64,${record?.qr}`}
                        alt="Base64 Image"
                      />
                    ),
                  },
                  {
                    title: "Action",
                    key: "action",
                    width: "10%",
                    align: "center",
                    render: (_, record) => {
                      return (
                        <Button
                          type="text"
                          icon={<Printer size={20} style={{ color: defaultColors.primary }} />}
                          onClick={() => {
                            set_show_qr(true);
                            set_qr_image(record);
                          }}
                        />
                      );
                    },
                  },
                ]
              : [
                  {
                    dataIndex: "ingredent_material_name",
                    title: "Material Name",
                    key: "ingredent_material_name",
                    width: "30%",
                    render: (_, record) => record?.ingredent_material_name,
                  },
                  {
                    dataIndex: "qr_number",
                    title: "QR Number",
                    key: "qr_number",
                    width: "15%",
                    align: "center",
                  },
                  {
                    dataIndex: "bag_number",
                    title: "Bag Number",
                    key: "bag_number",
                    width: "15%",
                    align: "center",
                  },
                  {
                    dataIndex: "bag_size",
                    title: "Quantity",
                    key: "quantity",
                    width: "15%",
                    align: "center",
                  },
                  {
                    dataIndex: "packs",
                    title: "Packs",
                    key: "no_of_qrs",
                    width: "15%",
                    align: "center",
                  },
                  {
                    dataIndex: "lot_number",
                    title: "Lot No.",
                    key: "lot_number",
                    align: "center",
                    width: "15%",
                  },
                  {
                    dataIndex: "opening_date",
                    title: "Mfg Date",
                    key: "opening_date",
                    width: "15%",
                    align: "center",
                  },
                  {
                    dataIndex: "expiry_date",
                    title: "Expiry Date",
                    key: "expiry_date",
                    width: "15%",
                    align: "center",
                  },
                  {
                    dataIndex: "qr",
                    title: "QR",
                    key: "qr",
                    width: "40%",
                    align: "center",
                    render: (_, record, index) => (
                      <Image
                        width={200}
                        src={`data:image/png;base64,${record?.qr}`}
                        alt="Base64 Image"
                      />
                    ),
                  },
                  {
                    title: "Action",
                    key: "action",
                    width: "10%",
                    align: "center",
                    render: (_, record) => {
                      return (
                        <Button
                          type="text"
                          icon={<Printer size={20} style={{ color: defaultColors.primary }} />}
                          onClick={() => {
                            set_show_qr(true);
                            set_selectedMaterial(record?.ingredent_material_id);
                            set_selectedMaterialUnit(record?.ingredent_material_unit);
                            set_qr_image(record);
                          }}
                        />
                      );
                    },
                  },
                ]?.filter(Boolean)
          }
          scrollX={940}
          height="calc(100vh - 390px)"
          bordered
          pagination={false}
        />
      </Modal>
      <QrPrinter
        show_qr={show_qr}
        set_show_qr={set_show_qr}
        set_qr_image={set_qr_image}
        qr_image={qr_image}
        componentRef={componentRef}
        from={from}
        material_id={selectedMaterial}
        material_unit={selectedMaterialUnit}
      />
    </MainCard>
  );
}

export default GenerateQRs;
